module.exports = __webpack_public_path__ + "static/media/prestau-placeholder.df39ee2f.png";